
































































































































































































import Vue from "vue";
import moment from "moment";

// Vuex
import { RootState } from "@/store";
import { mapGetters, mapMutations, mapState } from "vuex";
import * as m from "@/store/modules/LicenseModule/mutations";

// Vue components
import LicenseModuleCheckbox from "./LicenseModuleCheckbox.vue";
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";

import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import LicenseModuleFilter from "@/components/TableHeaderFilters/LicenseModuleFilter.vue";
import LicensesConfirmationModal from "./LicensesConfirmationModal.vue";
import DeleteInstallationsConfirmationModal from "./DeleteInstallationsConfirmationModal.vue";
import GlobalStatusInstallationChip from "@/views/App/Components/chips/GlobalStatusInstallationChip.vue";
import ConnectivityStatusChip from "@/views/App/Components/chips/ConnectivityStatusChip.vue";
import InstallationStatusTableHeaderFilter from "@/components/InstallationStatusTableHeaderFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import ConnectivityStatusFilter from "@/components/TableHeaderFilters/ConnectivityStatusFilter.vue";

// Model
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { dataTableItemsPerPage } from "@/utility/Constants";
import { DeleteInstallationsRequestDownloadCommand } from "@/model/communication/authActions/DeleteInstallationsRequestDownloadCommand";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import VFaIcon from "@/components/VFaIcon.vue";
import { ClientUser } from "@/model/data/authentication/ClientUser";

export default Vue.extend({
    components: {
        LicenseModuleCheckbox,
        TableFiltersRow,
        LicensesConfirmationModal,
        DeleteInstallationsConfirmationModal,
        GlobalStatusInstallationChip,
        VFaIcon,
        ColumnVisibilityFilter,
        ConnectivityStatusChip,
    },
    data() {
        return {
            moment,
            ClientPrivileges,
            LicenseModuleEnum,
            dataTableItemsPerPage,
            BranchFilter,
            DateRangeFilter,
            LicenseModuleFilter,
            ignoreOptionsChanges: false,
            ignoreDataChanges: false,
            confirmationDialog: false,
            options: {},
            canDeleteInstallations: false,
            selectedItems: [],
            deleteInstallationsConfirmationDialog: false,
            deleteInstallationsRequestDownloading: false,
            availableHeaders: [],
            filters: [
                {
                    headerValue: "status",
                    filterKey: "globalStatusFilter",
                    component: InstallationStatusTableHeaderFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "connectivityStatus",
                    filterKey: "connectivityStatusFilter",
                    component: ConnectivityStatusFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastMessage",
                    filterKey: "installationLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_installation_message") }),
                },
                {
                    headerValue: "agentInfo.lastMessage",
                    filterKey: "agentLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
                {
                    headerValue: "licenseData.registration",
                    filterKey: "registrationDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("licensesManagement.registrationDate") }),
                },
                {
                    headerValue: "ServiceAndUpdatesManagement",
                    filterKey: "ServiceAndUpdatesManagement",
                    component: LicenseModuleFilter,
                    currentSelections: -1,
                },
                {
                    headerValue: "CashFlowManagement",
                    filterKey: "CashFlowManagement",
                    component: LicenseModuleFilter,
                    currentSelections: -1,
                },
                {
                    headerValue: "FitnessStatistics",
                    filterKey: "FitnessStatistics",
                    component: LicenseModuleFilter,
                    currentSelections: -1,
                },
                {
                    headerValue: "SecurityManagement",
                    filterKey: "SecurityManagement",
                    component: LicenseModuleFilter,
                    currentSelections: -1,
                },
                {
                    headerValue: "PredictiveMaintenance",
                    filterKey: "PredictiveMaintenance",
                    component: LicenseModuleFilter,
                    currentSelections: -1,
                },
                {
                    headerValue: "RemoteLink",
                    filterKey: "RemoteLink",
                    component: LicenseModuleFilter,
                    currentSelections: -1,
                },
                {
                    headerValue: "OneTimeCode",
                    filterKey: "OneTimeCode",
                    component: LicenseModuleFilter,
                    currentSelections: -1,
                },
                {
                    headerValue: "DataFlow",
                    filterKey: "DataFlow",
                    component: LicenseModuleFilter,
                    currentSelections: -1,
                },
            ],
        };
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
        isSaveButtonEnable: { required: true, type: Boolean },
    },
    computed: {
        ...mapState({
            // installations: (state: RootState) => state.license.installations,
            localInstallations: (state: RootState) => state.license.localInstallations,
            authUser: (state: RootState) => state.authMod.currentUser,
            licensesDataSummary: (state: RootState) => state.license.licensesDataSummaryLocal,
            isCloud: (state: RootState) => state.application.isCloud,
        }),
        ...mapGetters(["isUserSuperAdmin"]),

        authActionsEnabled() {
            return (this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.AuthActions) == ClientPrivileges.AuthActions;
        },

        initialAvailableHeaders() {
            let availableHeaders: Array<object> = [
                {
                    enabled: true,
                    text: this.$t("common.installationStatus"),
                    value: "status",
                    sortable: false,
                    width: "1px",
                },
                {
                    enabled: true,
                    text: this.$t("common.connectivityStatus"),
                    value: "connectivityStatus",
                },
                {
                    enabled: true,
                    canBeHidden: false,
                    text: this.$t("common.installationName"),
                    value: "name",
                    width: "13%",
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("common.branch"),
                    value: "branch.name",
                    width: "13%",
                },
                {
                    enabled: false,
                    canBeHidden: true,
                    text: this.$t("common.pcName"),
                    value: "connectedPc",
                    sortable: false,
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("common.last_update"),
                    value: "lastMessage",
                    width: "120px",
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("common.last_agent_message"),
                    value: "agentInfo.lastMessage",
                    width: "120px",
                },
                { enabled: false, text: this.$t("common.agent_ip"), value: "agentInfo.ip", sortable: false },
                { enabled: false, text: this.$t("device_status.agent_remote_ip"), value: "agentInfo.remoteIp", sortable: false },
                {
                    enabled: false,
                    canBeHidden: true,
                    text: this.$t("common.agent_version"),
                    value: "agentInfo.version",
                    width: "1px",
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("licensesManagement.registrationDate"),
                    value: "licenseData.registration",
                    width: "120px",
                },
            ];
            for (let license of this.licensesDataSummary) {
                if (license.module == LicenseModuleEnum.CashFlowManagement && license.totalLicenses > 0)
                    availableHeaders.push({
                        enabled: true,
                        canBeHidden: false,
                        text: this.$t("common.license_module.cash_flow_management"),
                        value: "CashFlowManagement",
                        width: "8%",
                        sortable: false,
                        align: "center",
                    });
                if (license.module == LicenseModuleEnum.ServiceAndUpdatesManagement && license.totalLicenses > 0)
                    availableHeaders.push({
                        enabled: true,
                        canBeHidden: false,
                        text: this.$t("common.license_module.service_and_updates_management"),
                        value: "ServiceAndUpdatesManagement",
                        width: "8%",
                        sortable: false,
                        align: "center",
                    });
                if (license.module == LicenseModuleEnum.PredictiveMaintenance && license.totalLicenses > 0)
                    availableHeaders.push({
                        enabled: true,
                        canBeHidden: false,
                        text: this.$t("common.license_module.predictive_maintenance"),
                        value: "PredictiveMaintenance",
                        width: "8%",
                        sortable: false,
                        align: "center",
                    });
                if (license.module == LicenseModuleEnum.RemoteLink && license.totalLicenses > 0)
                    availableHeaders.push({
                        enabled: true,
                        canBeHidden: false,
                        text: this.$t("common.license_module.remote_link"),
                        value: "RemoteLink",
                        width: "8%",
                        sortable: false,
                        align: "center",
                    });
                if (license.module == LicenseModuleEnum.OneTimeCode && license.totalLicenses > 0)
                    availableHeaders.push({
                        enabled: true,
                        canBeHidden: false,
                        text: this.$t("common.license_module.one_time_code"),
                        value: "OneTimeCode",
                        width: "8%",
                        sortable: false,
                        align: "center",
                    });
                if (license.module == LicenseModuleEnum.SecurityManagement && license.totalLicenses > 0)
                    availableHeaders.push({
                        enabled: true,
                        canBeHidden: false,
                        text: this.$t("common.license_module.security_management"),
                        value: "SecurityManagement",
                        width: "8%",
                        sortable: false,
                        align: "center",
                    });
                if (license.module == LicenseModuleEnum.FitnessStatistics && license.totalLicenses > 0)
                    availableHeaders.push({
                        enabled: true,
                        canBeHidden: false,
                        text: this.$t("common.license_module.fitness_statistics"),
                        value: "FitnessStatistics",
                        width: "8%",
                        sortable: false,
                        align: "center",
                    });
                if (license.module == LicenseModuleEnum.DataFlow && license.totalLicenses > 0)
                    availableHeaders.push({
                        enabled: true,
                        canBeHidden: false,
                        text: this.$t("common.license_module.dataflow"),
                        value: "DataFlow",
                        width: "8%",
                        sortable: false,
                        align: "center",
                    });
            }
            return availableHeaders;
        },
    },
    watch: {
        options: {
            handler(newOptions) {
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },

        installations: {
            handler(newValue) {
                this[m.SET_LOCAL_INSTALLATIONS](newValue);
                this[m.RESET_LICENSE_LOCALLY](newValue);
            },
            deep: true,
        },

        canDeleteInstallations() {
            this.selectedItems = [];
        },
    },
    methods: {
        ...mapMutations([m.SET_LOCAL_INSTALLATIONS, m.RESET_LICENSE_LOCALLY]),
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },
        editLicenseDisabled(item) {
            if (this.isCloud && this.isUserSuperAdmin) return false;
            return item.licenseData.daysToChangeModules <= 0;
        },
        async deleteInstallationsRequestDownload() {
            console.log("deleteInstallationsRequestDownload()");

            try {
                this.deleteInstallationsRequestDownloading = true;
                const res = await new DeleteInstallationsRequestDownloadCommand(this.selectedItems.map((inst) => inst.name)).execute();

                if (res.status == 200) {
                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.deleteInstallationsConfirmationDialog = false;
                }
                this.deleteInstallationsRequestDownloading = false;
            } catch (e) {
                console.log("Something went wrong during AuthActionRequestDownloadCommand execution: ", e);
                this.deleteInstallationsRequestDownloading = false;
            }
        },
    },
});
